const middleware = {}

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['authRedirect'] = require('../middleware/authRedirect.js')
middleware['authRedirect'] = middleware['authRedirect'].default || middleware['authRedirect']

middleware['navigationGuard'] = require('../middleware/navigationGuard.js')
middleware['navigationGuard'] = middleware['navigationGuard'].default || middleware['navigationGuard']

export default middleware
